import { turnInfo, type DealRecord, type MatchState } from '../game/match';

/** One dot per hand in a dealer's turn: saved, Guaa, the hand being dealt, or still to come. */
export function HandPips({
  deals,
  current,
  size = 'md',
}: {
  /** Recorded deal, `'current'`, or `null` for upcoming — in hand order. */
  deals: (DealRecord | 'current' | null)[];
  current?: boolean;
  size?: 'sm' | 'md';
}) {
  const box = size === 'md' ? 'h-6 min-w-6 text-[11px]' : 'h-4 min-w-4 text-[9px]';
  return (
    <ol className="flex items-center gap-1.5" aria-hidden>
      {deals.map((d, i) => {
        let cls = 'ring-1 ring-inset ring-current/30 opacity-60';
        let text = String(i + 1);
        if (d === 'current') {
          cls = `bg-gold text-ink ${current ? 'animate-pulse-ring' : ''}`;
        } else if (d?.result === 'saved') {
          cls = 'bg-success-600 text-white';
          text = '✓';
        } else if (d?.result === 'guaa') {
          cls = 'bg-suit-red text-white';
          text = `+${d.guaaA + d.guaaB}`;
        }
        return (
          <li key={i} className={`grid place-items-center rounded-full px-1 font-bold tabular-nums ${box} ${cls}`}>
            {text}
          </li>
        );
      })}
    </ol>
  );
}

/** The hands of the dealer turn that contains `dealNo`. */
export function turnHands(state: MatchState, dealNo: number): (DealRecord | 'current' | null)[] {
  const { dealInTurn, dealsPerTurn } = turnInfo(state, dealNo);
  const first = dealNo - dealInTurn + 1;
  return Array.from({ length: dealsPerTurn }, (_, i) => {
    const n = first + i;
    if (state.deals[n - 1]) return state.deals[n - 1]!;
    return n === state.deals.length + 1 ? 'current' : null;
  });
}

